import React, { lazy, Suspense } from 'react';

import { Head as SEO } from '@landing/components';
import Header from 'components/Header';
import { Main } from 'components/UI';
import Intro from 'features/Intro';
import AboutTheCourse from 'features/AboutTheCourse';
import Directions from 'features/Directions';
import Benefits from 'features/Benefits';
import ContentWithItems from 'components/ContentWithItems';
import CountCard from 'features/CountCard';
import Statistics from 'features/Statistics';
import FormerTrainees from 'features/FormerTrainees';
import SocialMedia from 'features/SocialMedia';
import Footer from 'components/Footer';
import CookiesPolicy from 'components/CookiesPolicy';
import { anchorLinks } from 'define/anchorLinks';
import { useIsSsr } from 'utils/hooks';

import data from './data.json';

const ConsentModal = lazy(() =>
  import('components/Modals').then(({ ConsentModal }) => ({
    default: ConsentModal,
  })),
);

export default function Index() {
  const isSsr = useIsSsr();

  return (
    <>
      <Header anchorLinks={anchorLinks} />
      <Main overflow="hidden">
        <Intro {...data.intro} />
        <AboutTheCourse {...data.about} />
        <Directions {...data.directions} />
        <Benefits {...data.benefits} />
        <ContentWithItems Item={CountCard} {...data.internshipStages} />
        <Statistics {...data.statistics} />
        <FormerTrainees {...data.formerTrainees} />
        <SocialMedia {...data.socialMedia} />
      </Main>
      <Footer />
      <CookiesPolicy />
      {!isSsr && (
        <Suspense fallback={null}>
          <ConsentModal />
        </Suspense>
      )}
    </>
  );
}

export const Head = () => <SEO {...data.head} />;
